import { useRouter } from "next/router"
import Anchor from "../../components/anchor/anchor"
import Body from "../../components/body/body"
import Information from "../../components/register/information"
import { fetchApi } from "../../network/fetch"
import { CenterContainer } from "../../styles"

const Register = () => {
	const router = useRouter()
	const registerStep = 0

	let content
	switch (registerStep) {
		case 0:
			content = (
				<Information
					onContinue={async ({ name, password, email }) => {
						const result = await fetchApi(
							"/users/register",
							{ email, password, name },
							"POST"
						)
						if (result) {
							router.push("/register/confirmation")
						}
					}}
				/>
			)
			break

		// case 1:
		// 	content = (
		// 		// <ConnectServices onContinue={(data) => dispatch(updateUser(data))} />
		// 	)
		// 	break

		default:
			break
	}

	return (
		<Body subtitle="Register">
			<CenterContainer width="500px" style={{ flex: 1 }}>
				<p
					style={{ alignSelf: "flex-start", marginBottom: "20px" }}
					className="text-sm"
				>
					Already have an account? <Anchor href="/login">Login!</Anchor>
				</p>

				{content}
			</CenterContainer>
		</Body>
	)
}

export default Register
